import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { INVOICE_CODE } from "../apiRoutes";

interface InvoiceCodeResponse {
  data: any;
}

const fetchInvoiceCodeDetail = async (id: string) => {
  const response = await axiosAuth.get<InvoiceCodeResponse>(
    `${INVOICE_CODE}${id}`
  );
  return response.data;
};

const useGetInvoiceCodeDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["invoiceCodeDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["invoiceCodeDetail", string | undefined]>({
    queryKey: ["invoiceCodeDetail", id],
    queryFn: () => fetchInvoiceCodeDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetInvoiceCodeDetailQuery;


